export const immigrationContent = {
  employmentBased: {
    en: {
      title: "Employment-Based Immigration",
      subtitle: "Secure your American Dream through work-based visa and green card options",
      sections: [
        {
          title: "Work Your Way to Permanent Residency",
          content: "Employment-based immigration offers a pathway to permanent residency for skilled workers, professionals, and investors. Whether you're seeking an H-1B visa, L-1 transfer, or EB green card, we guide you through every step of the complex process."
        },
        {
          title: "Employment Visa Categories",
          items: [
            "H-1B Specialty Occupation Visas",
            "L-1 Intracompany Transferee Visas",
            "O-1 Extraordinary Ability Visas",
            "TN NAFTA Professional Visas",
            "E-2 Treaty Investor Visas",
            "EB-1, EB-2, EB-3 Green Cards"
          ]
        }
      ],
      faq: [
        {
          question: "What is the H-1B visa lottery?",
          answer: "The H-1B lottery is a random selection process used when applications exceed the annual cap of 65,000 visas (plus 20,000 for advanced degree holders). Your employer must register during the designated period, typically in March."
        },
        {
          question: "Can I change employers on an H-1B visa?",
          answer: "Yes, you can change employers through a process called 'H-1B transfer.' The new employer must file a new H-1B petition, and you can typically start working once it's filed (before approval)."
        }
      ]
    },
    es: {
      title: "Inmigración Basada en Empleo",
      subtitle: "Asegure su Sueño Americano a través de opciones de visa y tarjeta verde basadas en trabajo",
      sections: [
        {
          title: "Trabaje para su Residencia Permanente",
          content: "La inmigración basada en empleo ofrece un camino hacia la residencia permanente para trabajadores calificados, profesionales e inversionistas. Ya sea que busque una visa H-1B, transferencia L-1 o tarjeta verde EB, lo guiamos en cada paso del complejo proceso."
        },
        {
          title: "Categorías de Visa de Empleo",
          items: [
            "Visas H-1B para Ocupaciones Especializadas",
            "Visas L-1 de Transferencia Intracompañía",
            "Visas O-1 de Habilidad Extraordinaria",
            "Visas TN Profesional NAFTA",
            "Visas E-2 de Inversionista por Tratado",
            "Tarjetas Verdes EB-1, EB-2, EB-3"
          ]
        }
      ],
      faq: [
        {
          question: "¿Qué es la lotería de visa H-1B?",
          answer: "La lotería H-1B es un proceso de selección aleatoria usado cuando las solicitudes exceden el límite anual de 65,000 visas (más 20,000 para titulares de grado avanzado). Su empleador debe registrarse durante el período designado, típicamente en marzo."
        },
        {
          question: "¿Puedo cambiar de empleador con una visa H-1B?",
          answer: "Sí, puede cambiar de empleador mediante un proceso llamado 'transferencia H-1B'. El nuevo empleador debe presentar una nueva petición H-1B, y generalmente puede comenzar a trabajar una vez presentada (antes de la aprobación)."
        }
      ]
    },
    vi: {
      title: "Di Trú Dựa Trên Việc Làm",
      subtitle: "Bảo đảm Giấc Mơ Mỹ của bạn thông qua các lựa chọn visa và thẻ xanh dựa trên công việc",
      sections: [
        {
          title: "Làm Việc Để Được Thường Trú",
          content: "Di trú dựa trên việc làm cung cấp con đường đến thường trú cho công nhân lành nghề, chuyên gia và nhà đầu tư. Cho dù bạn đang tìm kiếm visa H-1B, chuyển nhượng L-1 hay thẻ xanh EB, chúng tôi hướng dẫn bạn qua từng bước của quy trình phức tạp."
        },
        {
          title: "Các Loại Visa Việc Làm",
          items: [
            "Visa H-1B Nghề Chuyên Môn",
            "Visa L-1 Chuyển Nhượng Nội Bộ Công Ty",
            "Visa O-1 Khả Năng Phi Thường",
            "Visa TN Chuyên Gia NAFTA",
            "Visa E-2 Nhà Đầu Tư Theo Hiệp Ước",
            "Thẻ Xanh EB-1, EB-2, EB-3"
          ]
        }
      ],
      faq: [
        {
          question: "Xổ số visa H-1B là gì?",
          answer: "Xổ số H-1B là quy trình chọn ngẫu nhiên được sử dụng khi đơn xin vượt quá hạn mức hàng năm 65,000 visa (cộng 20,000 cho người có bằng cao cấp). Nhà tuyển dụng của bạn phải đăng ký trong thời gian được chỉ định, thường là vào tháng Ba."
        },
        {
          question: "Tôi có thể đổi nhà tuyển dụng với visa H-1B không?",
          answer: "Có, bạn có thể đổi nhà tuyển dụng thông qua quy trình gọi là 'chuyển nhượng H-1B'. Nhà tuyển dụng mới phải nộp đơn H-1B mới, và bạn thường có thể bắt đầu làm việc khi đã nộp (trước khi được phê duyệt)."
        }
      ]
    }
  },
  familyBased: {
    en: {
      title: "Family-Based Immigration",
      subtitle: "Reunite with loved ones through family-based immigration petitions",
      sections: [
        {
          title: "Reunite with Loved Ones",
          content: "Family is at the heart of U.S. immigration law. If you're a U.S. citizen or lawful permanent resident, you may be eligible to sponsor certain family members for green cards. At Daniel Albert Law Firm, we help families navigate the family-based immigration process with clarity and compassion."
        },
        {
          title: "Who Can You Sponsor?",
          content: "U.S. citizens can sponsor immediate relatives (spouses, unmarried children under 21, and parents) as well as other family members. Lawful permanent residents can sponsor spouses and unmarried children. We'll help you understand eligibility requirements and guide you through the petition process."
        },
        {
          title: "Our Services Include",
          items: [
            "Filing Form I-130 (Petition for Alien Relative)",
            "Preparing supporting documentation",
            "Attending interviews with you",
            "Handling consular processing or adjustment of status",
            "Addressing any complications that arise during the process"
          ]
        }
      ],
      faq: [
        {
          question: "How long does family-based immigration take?",
          answer: "Processing times vary depending on the relationship and visa category. Immediate relatives of U.S. citizens typically have shorter wait times (8-14 months), while other family preference categories may take several years due to visa backlogs."
        },
        {
          question: "What documents do I need?",
          answer: "Common documents include proof of relationship (birth certificates, marriage certificates), proof of U.S. citizenship or permanent residence, financial documents (Affidavit of Support), and identity documents. We'll provide a complete checklist for your specific case."
        }
      ]
    },
    es: {
      title: "Inmigración Basada en Familia",
      subtitle: "Reúnase con sus seres queridos a través de peticiones de inmigración familiar",
      sections: [
        {
          title: "Reúnase con sus Seres Queridos",
          content: "La familia está en el corazón de la ley de inmigración de EE.UU. Si es ciudadano estadounidense o residente permanente legal, puede ser elegible para patrocinar a ciertos miembros de la familia para tarjetas verdes. En Daniel Albert Law Firm, ayudamos a las familias a navegar el proceso de inmigración familiar con claridad y compasión."
        },
        {
          title: "¿A Quién Puede Patrocinar?",
          content: "Los ciudadanos estadounidenses pueden patrocinar a familiares inmediatos (cónyuges, hijos solteros menores de 21 años y padres), así como a otros miembros de la familia. Los residentes permanentes legales pueden patrocinar a cónyuges e hijos solteros. Le ayudaremos a comprender los requisitos de elegibilidad y lo guiaremos a través del proceso de petición."
        },
        {
          title: "Nuestros Servicios Incluyen",
          items: [
            "Presentación del Formulario I-130 (Petición para Familiar Extranjero)",
            "Preparación de documentación de respaldo",
            "Asistir a entrevistas con usted",
            "Manejo del procesamiento consular o ajuste de estatus",
            "Abordar cualquier complicación que surja durante el proceso"
          ]
        }
      ],
      faq: [
        {
          question: "¿Cuánto tiempo toma la inmigración basada en familia?",
          answer: "Los tiempos de procesamiento varían según la relación y la categoría de visa. Los familiares inmediatos de ciudadanos estadounidenses generalmente tienen tiempos de espera más cortos (8-14 meses), mientras que otras categorías de preferencia familiar pueden tomar varios años debido a los retrasos de visas."
        },
        {
          question: "¿Qué documentos necesito?",
          answer: "Los documentos comunes incluyen prueba de relación (certificados de nacimiento, certificados de matrimonio), prueba de ciudadanía estadounidense o residencia permanente, documentos financieros (Declaración Jurada de Apoyo) y documentos de identidad. Le proporcionaremos una lista de verificación completa para su caso específico."
        }
      ]
    },
    vi: {
      title: "Di Trú Dựa Trên Gia Đình",
      subtitle: "Đoàn tụ với người thân thông qua đơn xin di trú dựa trên gia đình",
      sections: [
        {
          title: "Đoàn Tụ Với Người Thân",
          content: "Gia đình là trọng tâm của luật di trú Hoa Kỳ. Nếu bạn là công dân Hoa Kỳ hoặc thường trú nhân hợp pháp, bạn có thể đủ điều kiện bảo lãnh một số thành viên gia đình để nhận thẻ xanh. Tại Daniel Albert Law Firm, chúng tôi giúp các gia đình điều hướng quy trình di trú dựa trên gia đình một cách rõ ràng và thấu hiểu."
        },
        {
          title: "Bạn Có Thể Bảo Lãnh Ai?",
          content: "Công dân Hoa Kỳ có thể bảo lãnh người thân trực tiếp (vợ/chồng, con chưa kết hôn dưới 21 tuổi và cha mẹ) cũng như các thành viên gia đình khác. Thường trú nhân hợp pháp có thể bảo lãnh vợ/chồng và con chưa kết hôn. Chúng tôi sẽ giúp bạn hiểu các yêu cầu đủ điều kiện và hướng dẫn bạn qua quy trình đơn."
        },
        {
          title: "Dịch Vụ Của Chúng Tôi Bao Gồm",
          items: [
            "Nộp Mẫu I-130 (Đơn Xin Cho Người Thân Nước Ngoài)",
            "Chuẩn bị tài liệu hỗ trợ",
            "Tham dự phỏng vấn cùng bạn",
            "Xử lý tiến trình lãnh sự hoặc điều chỉnh tình trạng",
            "Giải quyết mọi vấn đề phát sinh trong quá trình"
          ]
        }
      ],
      faq: [
        {
          question: "Di trú dựa trên gia đình mất bao lâu?",
          answer: "Thời gian xử lý khác nhau tùy thuộc vào mối quan hệ và loại visa. Người thân trực tiếp của công dân Hoa Kỳ thường có thời gian chờ ngắn hơn (8-14 tháng), trong khi các loại ưu tiên gia đình khác có thể mất vài năm do tồn đọng visa."
        },
        {
          question: "Tôi cần những tài liệu gì?",
          answer: "Các tài liệu phổ biến bao gồm bằng chứng về mối quan hệ (giấy khai sinh, giấy chứng nhận kết hôn), bằng chứng về quyền công dân Hoa Kỳ hoặc thường trú, tài liệu tài chính (Tờ Khai Hỗ Trợ), và tài liệu nhận dạng. Chúng tôi sẽ cung cấp danh sách kiểm tra đầy đủ cho trường hợp cụ thể của bạn."
        }
      ]
    }
  },
  deportationDefense: {
    en: {
      title: "Deportation & Removal Defense",
      subtitle: "Fight to stay in the United States with aggressive immigration defense",
      sections: [
        {
          title: "Defend Your Right to Stay",
          content: "Facing deportation is one of the most stressful situations an immigrant can face. Our experienced attorneys provide aggressive defense in immigration court, exploring every available option to keep you and your family in the United States."
        },
        {
          title: "Defense Strategies",
          items: [
            "Cancellation of Removal",
            "Asylum Applications in Court",
            "Adjustment of Status Defense",
            "Waivers of Inadmissibility",
            "Appeals to Board of Immigration Appeals (BIA)",
            "Motions to Reopen or Reconsider"
          ]
        }
      ],
      faq: [
        {
          question: "What should I do if I receive a Notice to Appear?",
          answer: "Contact an immigration attorney immediately. A Notice to Appear (NTA) starts removal proceedings. Time is critical - you'll have a court date and need to prepare your defense strategy right away."
        },
        {
          question: "Can I work while in removal proceedings?",
          answer: "It depends on your immigration status. If you have a valid work permit (EAD), you can continue working. However, if you're out of status, you generally cannot work legally during proceedings unless you apply for and receive work authorization."
        }
      ]
    },
    es: {
      title: "Defensa Contra Deportación y Remoción",
      subtitle: "Luche por permanecer en Estados Unidos con defensa de inmigración agresiva",
      sections: [
        {
          title: "Defienda su Derecho a Permanecer",
          content: "Enfrentar la deportación es una de las situaciones más estresantes que un inmigrante puede enfrentar. Nuestros abogados experimentados brindan defensa agresiva en la corte de inmigración, explorando todas las opciones disponibles para mantenerlo a usted y a su familia en Estados Unidos."
        },
        {
          title: "Estrategias de Defensa",
          items: [
            "Cancelación de Remoción",
            "Solicitudes de Asilo en Corte",
            "Defensa de Ajuste de Estatus",
            "Perdones de Inadmisibilidad",
            "Apelaciones ante la Junta de Apelaciones de Inmigración (BIA)",
            "Mociones para Reabrir o Reconsiderar"
          ]
        }
      ],
      faq: [
        {
          question: "¿Qué debo hacer si recibo un Aviso de Comparecencia?",
          answer: "Contacte a un abogado de inmigración inmediatamente. Un Aviso de Comparecencia (NTA) inicia procedimientos de remoción. El tiempo es crítico: tendrá una fecha de corte y necesita preparar su estrategia de defensa de inmediato."
        },
        {
          question: "¿Puedo trabajar durante procedimientos de remoción?",
          answer: "Depende de su estatus migratorio. Si tiene un permiso de trabajo válido (EAD), puede seguir trabajando. Sin embargo, si está fuera de estatus, generalmente no puede trabajar legalmente durante los procedimientos a menos que solicite y reciba autorización de trabajo."
        }
      ]
    },
    vi: {
      title: "Phòng Thủ Trục Xuất & Di Dời",
      subtitle: "Chiến đấu để ở lại Hoa Kỳ với phòng thủ di trú mạnh mẽ",
      sections: [
        {
          title: "Bảo Vệ Quyền Ở Lại",
          content: "Đối mặt với trục xuất là một trong những tình huống căng thẳng nhất mà người nhập cư có thể gặp phải. Các luật sư giàu kinh nghiệm của chúng tôi cung cấp sự bảo vệ mạnh mẽ tại tòa án di trú, khám phá mọi lựa chọn có sẵn để giữ bạn và gia đình ở Hoa Kỳ."
        },
        {
          title: "Chiến Lược Phòng Thủ",
          items: [
            "Hủy Bỏ Di Dời",
            "Đơn Xin Tị Nạn tại Tòa",
            "Phòng Thủ Điều Chỉnh Tình Trạng",
            "Miễn Trừ Không Được Chấp Nhận",
            "Kháng Cáo lên Hội Đồng Kháng Cáo Di Trú (BIA)",
            "Kiến Nghị Mở Lại hoặc Xem Xét Lại"
          ]
        }
      ],
      faq: [
        {
          question: "Tôi nên làm gì nếu nhận được Thông Báo Xuất Hiện?",
          answer: "Liên hệ với luật sư di trú ngay lập tức. Thông Báo Xuất Hiện (NTA) bắt đầu thủ tục di dời. Thời gian là quan trọng - bạn sẽ có ngày ra tòa và cần chuẩn bị chiến lược phòng thủ ngay lập tức."
        },
        {
          question: "Tôi có thể làm việc trong khi đang trong thủ tục di dời không?",
          answer: "Tùy thuộc vào tình trạng di trú của bạn. Nếu bạn có giấy phép làm việc hợp lệ (EAD), bạn có thể tiếp tục làm việc. Tuy nhiên, nếu bạn không có tình trạng hợp pháp, bạn thường không thể làm việc hợp pháp trong thủ tục trừ khi bạn xin và nhận được giấy phép làm việc."
        }
      ]
    }
  },
  waivers: {
    en: {
      title: "Waivers (I-601, I-601A, I-212)",
      subtitle: "Overcome inadmissibility grounds and unlock your path to U.S. residence",
      sections: [
        {
          title: "Overcoming Inadmissibility",
          content: "Being deemed inadmissible can derail your immigration plans. Whether it's due to unlawful presence, criminal convictions, fraud, or other grounds, waivers provide a path forward."
        }
      ],
      faq: [
        {
          question: "What is extreme hardship?",
          answer: "Extreme hardship goes beyond the normal hardship of family separation. It includes serious medical conditions, financial devastation, inability to relocate due to family or country conditions, and other extraordinary circumstances."
        }
      ]
    },
    es: {
      title: "Perdones (I-601, I-601A, I-212)",
      subtitle: "Supere causales de inadmisibilidad y desbloquee su camino a la residencia en EE.UU.",
      sections: [
        {
          title: "Superando la Inadmisibilidad",
          content: "Ser considerado inadmisible puede descarrilar sus planes de inmigración. Ya sea por presencia ilegal, condenas penales, fraude u otros motivos, los perdones proporcionan un camino a seguir."
        }
      ],
      faq: [
        {
          question: "¿Qué es dificultad extrema?",
          answer: "La dificultad extrema va más allá de la dificultad normal de separación familiar. Incluye condiciones médicas graves, devastación financiera, incapacidad de reubicarse debido a condiciones familiares o del país, y otras circunstancias extraordinarias."
        }
      ]
    },
    vi: {
      title: "Miễn Trừ (I-601, I-601A, I-212)",
      subtitle: "Vượt qua lý do không được nhập cảnh và mở khóa con đường đến cư trú tại Mỹ",
      sections: [
        {
          title: "Vượt Qua Không Được Nhập Cảnh",
          content: "Bị coi là không được nhập cảnh có thể làm trật bánh kế hoạch di trú của bạn. Cho dù đó là do hiện diện bất hợp pháp, án tù hình sự, gian lận hoặc các lý do khác, miễn trừ cung cấp con đường phía trước."
        }
      ],
      faq: [
        {
          question: "Khó khăn cực độ là gì?",
          answer: "Khó khăn cực độ vượt quá khó khăn bình thường của việc chia tách gia đình. Nó bao gồm các tình trạng y tế nghiêm trọng, tàn phá tài chính, không thể di chuyển do điều kiện gia đình hoặc quốc gia, và các trường hợp bất thường khác."
        }
      ]
    }
  },
  daca: {
    en: {
      title: "DACA - Deferred Action for Childhood Arrivals",
      subtitle: "Protection from deportation and work authorization for Dreamers",
      sections: [{ title: "Protect Your Future with DACA", content: "If you came to the United States as a child and meet certain criteria, you may qualify for DACA." }],
      faq: [{ question: "Can I travel outside the U.S. with DACA?", answer: "DACA recipients cannot travel internationally without advance parole." }]
    },
    es: {
      title: "DACA - Acción Diferida para los Llegados en la Infancia",
      subtitle: "Protección contra deportación y autorización de trabajo para Dreamers",
      sections: [{ title: "Proteja su Futuro con DACA", content: "Si llegó a Estados Unidos cuando era niño y cumple ciertos criterios, puede calificar para DACA." }],
      faq: [{ question: "¿Puedo viajar fuera de EE.UU. con DACA?", answer: "Los beneficiarios de DACA no pueden viajar internacionalmente sin permiso anticipado." }]
    },
    vi: {
      title: "DACA - Hoãn Trục Xuất cho Người Đến Khi Còn Nhỏ",
      subtitle: "Bảo vệ khỏi trục xuất và giấy phép làm việc cho Dreamers",
      sections: [{ title: "Bảo Vệ Tương Lai Của Bạn với DACA", content: "Nếu bạn đến Hoa Kỳ khi còn nhỏ và đáp ứng các tiêu chí nhất định, bạn có thể đủ điều kiện cho DACA." }],
      faq: [{ question: "Tôi có thể đi du lịch ra ngoài Mỹ với DACA không?", answer: "Người nhận DACA không thể đi du lịch quốc tế mà không có giấy phép trước." }]
    }
  },
  k1Visa: {
    en: { title: "K-1 Fiancé(e) Visa", subtitle: "Bring your fiancé(e) to the U.S. to marry", sections: [{ title: "K-1 Fiancé Visa Process", content: "The K-1 visa allows U.S. citizens to bring their foreign fiancé(e) to the United States to get married within 90 days." }] },
    es: { title: "Visa K-1 de Prometido(a)", subtitle: "Traiga a su prometido(a) a EE.UU. para casarse", sections: [{ title: "Proceso de Visa K-1 de Prometido", content: "La visa K-1 permite a los ciudadanos estadounidenses traer a su prometido(a) extranjero(a) a Estados Unidos para casarse dentro de 90 días." }] },
    vi: { title: "Visa K-1 Hôn Phu/Thê", subtitle: "Đưa hôn phu/thê của bạn đến Mỹ để kết hôn", sections: [{ title: "Quy Trình Visa K-1", content: "Visa K-1 cho phép công dân Mỹ đưa hôn phu/thê nước ngoài đến Hoa Kỳ để kết hôn trong vòng 90 ngày." }] }
  },
  asylum: {
    en: { title: "Asylum Services", subtitle: "Protection for those fleeing persecution", sections: [{ title: "Asylum Applications", content: "If you face persecution in your home country due to race, religion, nationality, political opinion, or membership in a particular social group, you may qualify for asylum." }] },
    es: { title: "Servicios de Asilo", subtitle: "Protección para quienes huyen de persecución", sections: [{ title: "Solicitudes de Asilo", content: "Si enfrenta persecución en su país de origen por raza, religión, nacionalidad, opinión política o pertenencia a un grupo social particular, puede calificar para asilo." }] },
    vi: { title: "Dịch Vụ Tị Nạn", subtitle: "Bảo vệ cho những người chạy trốn bức hại", sections: [{ title: "Đơn Xin Tị Nạn", content: "Nếu bạn đối mặt với bức hại ở quốc gia của mình do chủng tộc, tôn giáo, quốc tịch, quan điểm chính trị hoặc thành viên của nhóm xã hội cụ thể, bạn có thể đủ điều kiện xin tị nạn." }] }
  },
  citizenship: {
    en: { title: "Citizenship & Naturalization", subtitle: "Become a U.S. citizen through naturalization", sections: [{ title: "Naturalization Process", content: "If you've been a lawful permanent resident for at least 5 years (or 3 years if married to a U.S. citizen), you may be eligible to apply for citizenship." }] },
    es: { title: "Ciudadanía y Naturalización", subtitle: "Conviértase en ciudadano estadounidense mediante naturalización", sections: [{ title: "Proceso de Naturalización", content: "Si ha sido residente permanente legal durante al menos 5 años (o 3 años si está casado con un ciudadano estadounidense), puede ser elegible para solicitar la ciudadanía." }] },
    vi: { title: "Quốc Tịch & Nhập Tịch", subtitle: "Trở thành công dân Mỹ thông qua nhập tịch", sections: [{ title: "Quy Trình Nhập Tịch", content: "Nếu bạn đã là thường trú nhân hợp pháp trong ít nhất 5 năm (hoặc 3 năm nếu kết hôn với công dân Mỹ), bạn có thể đủ điều kiện nộp đơn xin quốc tịch." }] }
  },
  consularProcessing: {
    en: { title: "Consular Processing", subtitle: "Immigrant visa processing abroad", sections: [{ title: "Consular Processing Services", content: "Once your immigrant petition is approved, you'll complete the visa process at a U.S. consulate in your home country." }] },
    es: { title: "Procesamiento Consular", subtitle: "Procesamiento de visa de inmigrante en el extranjero", sections: [{ title: "Servicios de Procesamiento Consular", content: "Una vez que su petición de inmigrante sea aprobada, completará el proceso de visa en un consulado de EE.UU. en su país de origen." }] },
    vi: { title: "Xử Lý Lãnh Sự", subtitle: "Xử lý visa nhập cư ở nước ngoài", sections: [{ title: "Dịch Vụ Xử Lý Lãnh Sự", content: "Khi đơn nhập cư của bạn được chấp thuận, bạn sẽ hoàn thành quy trình visa tại lãnh sự quán Mỹ ở quốc gia của bạn." }] }
  },
  greenCardRenewal: {
    en: { title: "Green Card Renewal", subtitle: "Renew or replace your permanent resident card", sections: [{ title: "Green Card Renewal Services", content: "Green cards must be renewed every 10 years. Don't wait until it expires - apply for renewal 6 months before expiration." }] },
    es: { title: "Renovación de Tarjeta Verde", subtitle: "Renueve o reemplace su tarjeta de residente permanente", sections: [{ title: "Servicios de Renovación de Tarjeta Verde", content: "Las tarjetas verdes deben renovarse cada 10 años. No espere hasta que expire: solicite la renovación 6 meses antes del vencimiento." }] },
    vi: { title: "Gia Hạn Thẻ Xanh", subtitle: "Gia hạn hoặc thay thế thẻ thường trú nhân", sections: [{ title: "Dịch Vụ Gia Hạn Thẻ Xanh", content: "Thẻ xanh phải được gia hạn mỗi 10 năm. Đừng đợi đến khi hết hạn - nộp đơn gia hạn 6 tháng trước khi hết hạn." }] }
  },
  uvisa: {
    en: { title: "U Visa for Crime Victims", subtitle: "Immigration relief for crime victims who assist law enforcement", sections: [{ title: "U Visa Services", content: "If you've been a victim of qualifying crime and helped law enforcement, you may be eligible for a U visa." }] },
    es: { title: "Visa U para Víctimas de Crimen", subtitle: "Alivio migratorio para víctimas de crimen que ayudan a las autoridades", sections: [{ title: "Servicios de Visa U", content: "Si ha sido víctima de un crimen calificado y ayudó a las autoridades, puede ser elegible para una visa U." }] },
    vi: { title: "Visa U cho Nạn Nhân Tội Phạm", subtitle: "Cứu trợ di trú cho nạn nhân tội phạm hỗ trợ cơ quan thực thi pháp luật", sections: [{ title: "Dịch Vụ Visa U", content: "Nếu bạn là nạn nhân của tội phạm đủ điều kiện và giúp cơ quan thực thi pháp luật, bạn có thể đủ điều kiện xin visa U." }] }
  },
  vawa: {
    en: { title: "VAWA Petitions", subtitle: "Self-petition for abused spouses and children", sections: [{ title: "VAWA Services", content: "The Violence Against Women Act allows victims of domestic violence to self-petition for immigration status without their abuser's knowledge." }] },
    es: { title: "Peticiones VAWA", subtitle: "Auto-petición para cónyuges e hijos maltratados", sections: [{ title: "Servicios VAWA", content: "La Ley de Violencia Contra las Mujeres permite a las víctimas de violencia doméstica auto-peticionar estatus migratorio sin el conocimiento de su agresor." }] },
    vi: { title: "Đơn VAWA", subtitle: "Tự nộp đơn cho vợ/chồng và con bị lạm dụng", sections: [{ title: "Dịch Vụ VAWA", content: "Đạo luật Chống Bạo lực Phụ Nữ cho phép nạn nhân bạo lực gia đình tự nộp đơn xin tình trạng di trú mà không cần người lạm dụng biết." }] }
  }
};
